/**
 * The hooks the browser runtime hands to Sentry (instrumentation-client.ts),
 * kept here so a test runs exactly what the browser runs.
 *
 * (The browser SDK sends no client address of its own: `sendDefaultPii: false`
 * sets `infer_ip: never`. A `user.ip_address` set by hand is dropped by the
 * scrub.)
 */
import { isAbortedRequestEvent } from './ignore-client-noise'
import { scrubClientEvent } from './scrub-client-event'

type ClientEventLike = Parameters<typeof scrubClientEvent>[0] & Parameters<typeof isAbortedRequestEvent>[0]

/** `beforeSend`. */
export function clientBeforeSend<T extends ClientEventLike>(event: T): T | null {
  // A request the page cancelled itself is not a defect (HFV3-FRONTEND-P).
  if (isAbortedRequestEvent(event)) return null
  return scrubClientEvent(event)
}

/**
 * `beforeSendTransaction`. Transactions never pass through beforeSend. Until
 * this was wired the pageload transaction shipped the page URL — query, tokens
 * and all — in request.url and every browser-metrics span (2026-09-14
 * capture-server pass).
 */
export function clientBeforeSendTransaction<T extends ClientEventLike>(event: T): T | null {
  return scrubClientEvent(event)
}
